export default __webpack_public_path__ + "static/Logo-01b20f39685ce8660d3760548f01da6a.jpeg";